<!-- 赠送积分 -->

<template>
  <div class="gift-points-dialog">
    <w-dialog ref="dialogRef" title="赠送积分" width="35%" top="15vh" confirmText="确认赠送" @wConfirm="onConfirmBtn">
      <w-title :title_name="'基本信息'"></w-title>
      <div>
        <div class="flex">
          <div class="title-text flex-shrink">会员ID</div>
          <div class="text-hidden">{{ currentRow.m_id }}</div>
        </div>
        <div class="flex s-m-t">
          <div class="title-text flex-shrink">会员姓名</div>
          <div class="text-hidden">{{ currentRow.m_realname }}</div>
        </div>
        <div class="flex s-m-t">
          <div class="title-text flex-shrink">会员电话</div>
          <div class="text-hidden">{{ currentRow.m_mobile }}</div>
        </div>
        <div class="flex s-m-t">
          <div class="title-text flex-shrink">会员等级</div>
          <div class="text-hidden">{{ currentRow.m_level_label }}</div>
        </div>
        <div class="flex s-m-t">
          <div class="title-text flex-shrink">注册时间</div>
          <div class="text-hidden">{{ currentRow.m_ctime }}</div>
        </div>
      </div>

      <div class="l-m-t">
        <w-title :title_name="'积分规则'"></w-title>
        <div>
          <div class="flex">
            <div class="title-text flex-shrink">规则名称</div>
            <div class="text-hidden">{{ infoDatas.integral_rule.ir_title }}</div>
          </div>
          <div class="flex s-m-t">
            <div class="title-text flex-shrink">规则类型</div>
            <div class="text-hidden">{{ typeTexe(infoDatas.integral_rule.ir_type) }}</div>
          </div>
          <div class="flex s-m-t">
            <div class="title-text flex-shrink">细则</div>
            <div class="text-hidden">{{ infoDatas.integral_rule.ir_way_label }}</div>
          </div>
          <div class="flex s-m-t">
            <div class="title-text flex-shrink">生效时间</div>
            <div class="text-hidden">{{ infoDatas.integral_rule.ir_stime }}</div>
          </div>
        </div>
      </div>

      <div class="l-m-t">
        <div class="gift-title">本次赠送积分</div>
        <el-input v-model="infoDatas.integral_rule.ir_integration_num" readonly placeholder="请输入" />
      </div>
    </w-dialog>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  emits: ["submit"],
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前数据
    const infoDatas = ref('');  // 详情数据

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row, datas) => {
      currentRow.value = row;
      infoDatas.value = datas;
      dialogRef.value.show();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     * 处理规则类型
     * 
     * **/
    const typeTexe = (type) => {
      let type_text = '';  // 1: 消费积分；2：行为积分；3：等级积分；4：认证房产积分
      switch (type) {
        case 1:
          type_text = '消费积分';
          break;
        case 2:
          type_text = '行为积分';
          break;
        case 3:
          type_text = '等级积分';
          break;
        case 4:
          type_text = '认证房产积分';
          break;
      }
      return type_text;
    }
    /**
     * 
     * 确认按钮
     * 
     * **/
    const onConfirmBtn = () => {
      dialogRef.value.isLoading = true;
      let params = {
        action: 'send',
        m_id: currentRow.value.m_id,
        mr_room_id: infoDatas.value.base_info.mr_room_id,
      };
      emit("submit", params);
    }

    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      infoDatas,
      typeTexe,
      onConfirmBtn,
    };
  },
};
</script>

<style lang="scss">
.gift-points-dialog {
  .title-text {
    color: #92979E;
    width: 90px;
  }

  .gift-title {
    color: #262C30;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>